var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_2669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3152 7.15453C38.9511 3.74328 36.257 1.04858 32.8454 0.684814C24.2901 -0.228271 15.7098 -0.228271 7.15484 0.684814C3.74328 1.04889 1.04889 3.74328 0.684814 7.15453C-0.228271 15.7095 -0.228271 24.2901 0.684814 32.8451C1.04889 36.2567 3.74328 38.9511 7.15453 39.3152C15.7095 40.2282 24.2901 40.2282 32.8454 39.3152C36.257 38.9511 38.9511 36.2567 39.3152 32.8451C40.2282 24.2901 40.2282 15.7098 39.3152 7.15453Z",
    fill: "url(#paint0_radial_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1408 8.60131C36.8179 5.57428 34.4272 3.18323 31.3998 2.86005C23.8083 2.05011 16.1942 2.05011 8.60263 2.86005C5.57559 3.18323 3.18454 5.57428 2.86136 8.60131C2.05142 16.1929 2.05142 23.807 2.86136 31.3982C3.18454 34.4256 5.57559 36.8166 8.60263 37.1395C16.1942 37.9497 23.8083 37.9497 31.3995 37.1395C34.4269 36.8166 36.8179 34.4256 37.1408 31.3982C37.9511 23.807 37.9511 16.1929 37.1408 8.60131Z",
    fill: "url(#paint1_linear_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 32.016C0.629028 32.2924 0.65741 32.5689 0.687012 32.8454C1.05109 36.2567 3.74548 38.9511 7.15704 39.3151C15.712 40.2282 24.2926 40.2282 32.8476 39.3151C36.2592 38.9511 38.9533 36.2567 39.3173 32.8454C39.347 32.5689 39.3753 32.2924 39.4031 32.016H0.601562Z",
    fill: "url(#paint2_linear_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.316 32.8451C39.8067 28.2482 40.0331 23.6441 39.9965 19.0405L30.8534 9.89743C29.7112 8.59342 28.0428 7.77952 26.0823 7.70902C22.0506 7.56376 18.0062 7.57108 13.9739 7.70963C10.6249 7.82499 8.28296 10.076 7.68237 13.3844C7.57648 13.9685 7.513 14.5602 7.42969 15.1486V24.8477C7.47577 25.162 7.54352 25.4748 7.56458 25.791C7.69885 27.8033 8.52588 29.5269 9.85003 30.693L19.1542 39.9969C23.7203 40.0289 28.2866 39.8019 32.8462 39.3151C36.2578 38.9511 38.9519 36.2567 39.316 32.8451Z",
    fill: "url(#paint3_linear_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3149 32.8455C38.9511 36.2565 36.2561 38.9515 32.8451 39.3153C28.2861 39.8017 23.7189 40.0291 19.1534 39.997L9.86328 30.7069C10.9402 31.6495 12.3441 32.2236 13.9731 32.2849C18.0044 32.4363 22.0499 32.4323 26.0812 32.2871C29.7275 32.1552 32.366 29.4566 32.4798 25.8103C32.6013 21.9389 32.6013 18.0573 32.4798 14.1859C32.428 12.5038 31.8374 11.0237 30.8584 9.90366L39.9957 19.0409C40.0317 23.6439 39.8053 28.2487 39.3149 32.8455Z",
    fill: "url(#paint4_linear_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7204 15.6686C23.5492 14.3933 21.8686 13.5931 20.0006 13.5931C16.4624 13.5931 13.5938 16.4618 13.5938 20C13.5938 21.8679 14.3939 23.5485 15.6692 24.7198L30.4925 39.5431C31.2771 39.4747 32.0618 39.3988 32.8457 39.3151C36.2573 38.9511 38.9517 36.2567 39.3158 32.8451C39.3994 32.0611 39.4754 31.2765 39.5437 30.4919L24.7204 15.6686Z",
    fill: "url(#paint5_linear_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 24.3087L27.9937 12.3791C27.7154 12.0138 27.2769 11.7767 26.7822 11.7767C25.9405 11.7767 25.2578 12.4591 25.2578 13.3011C25.2578 13.7957 25.4949 14.2343 25.8602 14.5126L39.7103 28.363C39.8043 27.012 39.8754 25.6604 39.9236 24.3087Z",
    fill: "url(#paint6_linear_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42969 15.1486C7.513 14.5602 7.57648 13.9685 7.68237 13.3844C8.28265 10.076 10.6249 7.82499 13.9739 7.70963C18.0062 7.57108 22.0506 7.56376 26.0823 7.70902C29.7273 7.84025 32.3671 10.5392 32.4809 14.1855C32.6021 18.0572 32.6021 21.9384 32.4809 25.8102C32.3671 29.4564 29.7283 32.1551 26.0826 32.2866C22.051 32.4322 18.0055 32.4359 13.9742 32.2845C10.3285 32.1475 7.80841 29.4424 7.56458 25.7907C7.54352 25.4748 7.47577 25.1617 7.42969 24.8474C7.42969 21.6143 7.42969 18.3813 7.42969 15.1486ZM20.0041 30.1257C21.8492 30.1257 23.6962 30.1809 25.5388 30.1129C28.4279 30.0058 30.2049 28.2815 30.2724 25.3952C30.356 21.7987 30.356 18.1973 30.2724 14.6005C30.2049 11.7148 28.4267 9.95023 25.5388 9.88889C21.8733 9.81137 18.2039 9.81199 14.5384 9.88889C11.6725 9.94901 9.89032 11.6778 9.8125 14.5318C9.71362 18.1738 9.71362 21.8222 9.8125 25.4641C9.89032 28.3178 11.6725 30.0067 14.5388 30.1129C16.3582 30.1806 18.1822 30.1257 20.0041 30.1257Z",
    fill: "url(#paint7_linear_384_2669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42969 15.1484C7.513 14.5601 7.57648 13.9683 7.68237 13.3842C8.28265 10.0758 10.6249 7.82483 13.9739 7.70948C18.0062 7.57093 22.0506 7.5636 26.0823 7.70887C29.7273 7.84009 32.3671 10.5391 32.4809 14.1853C32.6021 18.0571 32.6021 21.9383 32.4809 25.81C32.3671 29.4563 29.7283 32.155 26.0826 32.2865C22.051 32.4321 18.0055 32.4357 13.9742 32.2843C10.3285 32.1473 7.80841 29.4422 7.56458 25.7905C7.54352 25.4747 7.47577 25.1616 7.42969 24.8472C7.42969 21.6142 7.42969 18.3812 7.42969 15.1484ZM20.0041 30.1255C21.8492 30.1255 23.6962 30.1808 25.5388 30.1127C28.4279 30.0056 30.2049 28.2814 30.2724 25.395C30.356 21.7985 30.356 18.1971 30.2724 14.6003C30.2049 11.7146 28.4267 9.95008 25.5388 9.88874C21.8733 9.81122 18.2039 9.81183 14.5384 9.88874C11.6725 9.94886 9.89032 11.6777 9.8125 14.5317C9.71362 18.1736 9.71362 21.822 9.8125 25.464C9.89032 28.3177 11.6725 30.0065 14.5388 30.1127C16.3582 30.1805 18.1822 30.1255 20.0041 30.1255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 13.5933C16.4624 13.5933 13.5938 16.4616 13.5938 19.9998C13.5938 23.5383 16.4624 26.4067 20.0006 26.4067C23.5391 26.4067 26.4075 23.5383 26.4075 19.9998C26.4075 16.4616 23.5391 13.5933 20.0006 13.5933ZM20.0006 24.2009C17.6804 24.2009 15.7996 22.3201 15.7996 19.9998C15.7996 17.6796 17.6804 15.7988 20.0006 15.7988C22.3209 15.7988 24.2017 17.6796 24.2017 19.9998C24.2017 22.3201 22.3209 24.2009 20.0006 24.2009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3062 13.3009C28.3062 14.1426 27.6238 14.8249 26.7822 14.8249C25.9405 14.8249 25.2578 14.1426 25.2578 13.3009C25.2578 12.4589 25.9405 11.7766 26.7822 11.7766C27.6238 11.7766 28.3062 12.4589 28.3062 13.3009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_384_2669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.19977 34.9568) scale(44.1129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544,
    stopColor: "#FADC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1167,
    stopColor: "#FBCE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#FCB720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    stopColor: "#FE9838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3054,
    stopColor: "#FF7950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#FF1C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C1CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_384_2669",
    x1: 15.3429,
    y1: 17.3796,
    x2: -52.4218,
    y2: -20.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#90A2BD",
    stopOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#7C8B9C",
    stopOpacity: 0.756863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_384_2669",
    x1: 20.0022,
    y1: 35.3098,
    x2: 20.0022,
    y2: 41.5448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#FCA800",
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FE7300",
    stopOpacity: 0.627451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8685,
    stopColor: "#FF5200",
    stopOpacity: 0.866667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_384_2669",
    x1: 17.7252,
    y1: 17.6678,
    x2: 7.82585,
    y2: 7.76842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_384_2669",
    x1: 27.4137,
    y1: 36.585,
    x2: 22.4728,
    y2: 13.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_384_2669",
    x1: 29.2947,
    y1: 29.2941,
    x2: 9.44913,
    y2: 9.44848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_384_2669",
    x1: 30.7673,
    y1: 17.2861,
    x2: 24.2047,
    y2: 10.7236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_384_2669",
    x1: 27.9428,
    y1: 12.1132,
    x2: 11.7619,
    y2: 28.2941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#9C3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2927,
    stopColor: "#DC2546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#FD1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#FC6831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6887,
    stopColor: "#FC9B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    stopColor: "#FCAF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7806,
    stopColor: "#FDB750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#FECB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#FFD87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_2669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramlogo);
export default __webpack_public_path__ + "static/media/instagramlogo.1c1f22c9c0ead158dc4ad295f033e64d.svg";
export { ForwardRef as ReactComponent };